import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const API_BASE_URL = 'https://erp-pmpc.ro/api';

const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: API_BASE_URL,
});
axiosInstance.interceptors.request.use(
  (config) => {
    config.headers['X-User-Permissions'] = localStorage.getItem('permissions');
    config.headers['X-Current-Page'] = window.location.href;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 403) {
      window.location.href = '/not_authorized'
      return Promise.reject(error);
    }
    else if (error.response && error.response.status === 401) {
      try {
        await axios.post(`${API_BASE_URL}/token/refresh/`, {}, { withCredentials: true });
        return axiosInstance.request(error.config);
      } catch (refreshError) {
        console.error('Token refresh failed:', refreshError);
        localStorage.clear();
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
